export var BACKSPACE = 8;
export var TAB = 9;
export var RETURN = 13;
export var ESC = 27;
export var SPACE = 32;
export var LEFT = 37;
export var UP = 38;
export var RIGHT = 39;
export var DOWN = 40;